import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { parseISO, format } from 'date-fns';
import _ from 'lodash';

import { UsersToolbar, OrdersTable } from './components';
import api from '../../common/apiService';
import config from '../../config/config.json';
import helpers from '../../helpers/helpers';

import { Snackbar } from '@material-ui/core';
// import MuiAlert from '@material-ui/lab/Alert';
import { useHistory } from 'react-router-dom';
import withAlert from '../../hoc/withAlert';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  }
}));

// function Alert(props) {
//   return <MuiAlert elevation={6} variant="filled" {...props} />;
// }

const OrderList = props => {
  const classes = useStyles();
  const [tickets, setTickets] = useState([]);
  let history = useHistory();
  // Заберем из HOC нужные методы для показа алерта
  const { setSnackMessage, setSnackType, setOpenSnack } = props;

  const prepareTickets = apiTickets => {
    // console.log('prepareTickets', apiTickets);
    const ticketsPrepared = _.map(apiTickets, (value, key) => {
      // const payedStatusLabels = _.filter(config.payedStatusLabels,['id',value.ticketstatuse_id])
      // console.log('payedStatusLabels',payedStatusLabels)
      return {
        id: value.id,
        price: value.manual_price,
        payedStatusLabel: _.filter(config.payedStatusLabels, [
          'id',
          value.ticketstatuse_id
        ])[0].label,
        payedStatusColor: _.filter(config.payedStatusLabels, [
          'id',
          value.ticketstatuse_id
        ])[0].color,
        created_at: format(parseISO(value.created_at), 'dd.MM.yyyy'),
        // meals: helpers.getMealCountLabel(value.meals),
        meals: JSON.stringify(value.meals),
        // meals:  JSON.stringify(_(value.meals).valuesIn()),
        // meals:  JSON.stringify(_(value.meals).toPairs().sortBy(0).fromPairs().valuesIn().join(' / ')),
        meal_min_date: format(parseISO(value.meal_min_date), 'dd.MM.yyyy'),
        meal_max_date: format(parseISO(value.meal_max_date), 'dd.MM.yyyy'),
        user: `${value.user.id}: ${value.user.name} ${value.user.surname}`.trim(),
        userTypeLabel: helpers.getCustomerTypeLabel(value.user.type),
        userType: value.user.type
      };
    });
    // console.log('ticketsPrepared',ticketsPrepared);
    return ticketsPrepared;
  };

  useEffect(() => {
    const getData = async () => {
      let apiTickets = await api.getTickets(config.eventId);
      apiTickets = prepareTickets(apiTickets);
      setTickets(apiTickets);
    };
    getData();
  }, []);

  const handleDeleteTicket = async id => {
    // console.log('handleDeleteTicket', id);

    try {
      const res = await api.deleteTicket(id);
      //  console.log('handleDeleteTicket res', res);
      if (res.status === 200) {
        setSnackMessage(`Билет ${id} удален`);
        setSnackType('success');
        setOpenSnack(true);
        const redirectUrl = '/';
        // history.replace(redirectUrl);
        setTimeout(() => {
          history.replace(redirectUrl);
        }, 1000);
      } else {
        setSnackMessage('Ошибка. Билет не удален');
        setSnackType('error');
        setOpenSnack(true);
      }
    } catch (error) {
      setSnackMessage(`Ошибка: ${error}`);
      setSnackType('error');
      setOpenSnack(true);
      return;
    }
  };

  return (
    <div className={classes.root}>
      {/* <Snackbar open={openSnack} autoHideDuration={3000} onClose={handleCloseSnack}>
    <Alert onClose={handleCloseSnack} severity={snackType}>
      {snackMessage}
    </Alert>
  </Snackbar> */}

      {/* <UsersToolbar /> */}
      <div className={classes.content}>
        <OrdersTable tickets={tickets} onDeleteTicket={handleDeleteTicket} />
      </div>
    </div>
  );
};

export default withAlert(OrderList);
